import { z } from 'zod';

export const InputSchema = z.object({
    accountId: z.number(),
});

export type GetTransactionsTotalDepositsSchemaType = z.infer<typeof InputSchema>;

export const SuccessResponseSchema = z.object({
    profit: z.string(),
    totalDeposits: z.string(),
});

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export type ResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | {
          responseStatus: 'error';
          status: number;
          unparsedData?: unknown;
      };
